var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVelo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#002069"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3478_13303)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.8671 40.3662L48.015 43.9191H37.1613V47.6883H45.9961L46.0378 47.7632L44.1983 51.2412H37.1613V55.0104H49.8128L49.8504 55.0853L48.015 58.5633H33.599V40.3662H49.8671Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8178 40.0168C84.5222 39.5551 89.6404 47.9214 85.5525 54.5029C81.7525 60.6227 72.7592 60.4605 69.1885 54.2076C65.7305 48.146 69.8518 40.4329 76.8178 40.0168ZM76.8929 43.5364C72.6215 43.8693 70.1354 48.6869 72.2127 52.4145C74.4736 56.4624 80.3676 56.5248 82.6618 52.4852C85.0812 48.2251 81.7358 43.1579 76.8888 43.5323L76.8929 43.5364Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4536 40.3662V55.0104H67.5785L65.7765 58.5633H52.9247V40.3662H56.4536Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5081 40.3662L19.0203 47.1142L22.5993 40.3662H26.1115L19.037 53.8996L12 40.3662H15.5081Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4383 40.3662L21.7025 58.9959C21.2311 58.0848 20.7222 57.1862 20.2634 56.271C20.1924 56.1295 19.9422 55.701 19.963 55.5804L27.8426 40.4619L27.926 40.3662H31.4341H31.4383Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3478_13303"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 19,
    fill: "white",
    transform: "translate(12 40)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVelo);
export default __webpack_public_path__ + "static/media/velo.0e8a016e759a6d833ea84f2016e0d74c.svg";
export { ForwardRef as ReactComponent };